<template>
  <div class="chart-content" :style="`width:${width}px;height:${height}px;`">
    <canvas ref="pupilchart" :width="width" :height="height"></canvas>
    <div class="chart-content-tip" ref="tooltip"></div>
  </div>
</template>

<script>
const mockData = {
  resultPupilDiameter: [
    193.8230438232422, 192.5129852294922, 193.88076782226562, 195.9170684814453, 200.18304443359375,
    204.48318481445312, 205.5386199951172, 204.551025390625, 205.3070831298828, 207.96905517578125,
    211.60960388183594, 215.9302520751953, 216.725341796875, 218.3577880859375, 219.90679931640625,
    222.43145751953125, 224.8557891845703, 227.3257598876953, 228.5314483642578, 231.11874389648438,
    230.93019104003906, 227.76193237304688, 223.4513397216797, 216.31573486328125,
    213.72616577148438, 210.6412811279297, 209.67832946777344, 211.4246368408203, 214.1801300048828,
    218.33346557617188, 218.10147094726562, 217.6844024658203, 216.19754028320312,
    212.3787841796875, 209.4767303466797, 208.02313232421875, 211.01806640625, 216.39199829101562,
    220.4126739501953, 224.20135498046875, 227.10047912597656, 228.89434814453125,
    229.23049926757812, 229.68211364746094, 230.03097534179688, 232.1790771484375,
    235.2671356201172, 238.53851318359375, 239.94947814941406, 241.7501220703125, 242.9032745361328,
    179.53273010253906, 240.08331298828125, 238.96182250976562, 239.08262634277344,
    241.1114959716797, -1000, 204.9377899169922, 226.93887329101562, 152.8516387939453,
    224.09262084960938, 203.6403045654297, -1000, 201.78392028808594, 247.5464630126953,
    249.7118377685547, 250.9935302734375, 249.42909240722656, 246.83926391601562,
    238.74594116210938, 232.28726196289062, 227.87332153320312, 228.45294189453125,
    230.7606964111328, 235.20709228515625, 239.98046875, 243.68524169921875, 247.66761779785156,
    248.98695373535156, 248.9362335205078, 246.2871856689453, 244.775146484375, 245.96951293945312,
    246.1607666015625, 247.0579376220703, 249.01254272460938, 249.77764892578125, 251.8585968017578,
    251.56484985351562, 251.16055297851562, 250.37596130371094, 249.74061584472656,
    247.58786010742188, 247.7743377685547, 247.9934539794922, 248.30072021484375, 248.61767578125,
    246.68426513671875, 247.80209350585938, 247.034912109375
  ],
  resultPupilCenterX: [
    520.0438232421875, 513.8671875, 488.7596740722656, 480.04376220703125, 468.384521484375,
    462.4510803222656, 467.9960021972656, 477.0593566894531, 481.49755859375, 479.3084411621094,
    483.4683532714844, 490.218994140625, 488.4552001953125, 487.8585510253906, 489.18572998046875,
    492.7644348144531, 492.7223815917969, 492.17340087890625, 483.932373046875, 495.6114501953125,
    494.4166259765625, 491.2113952636719, 488.5880432128906, 481.8064880371094, 470.6202087402344,
    471.4464111328125, 472.6548767089844, 473.1275329589844, 478.06707763671875, 477.5962829589844,
    498.85455322265625, 496.6075744628906, 512.2564086914062, 506.32574462890625,
    504.07391357421875, 511.2778015136719, 515.7818603515625, 513.1268920898438, 506.39373779296875,
    503.2960205078125, 503.53155517578125, 502.7009582519531, 502.2784729003906, 505.587890625,
    505.8348693847656, 502.5711364746094, 504.5958251953125, 507.5673522949219, 507.3949279785156,
    507.3271789550781, 504.2774658203125, 502.6627502441406, 503.4896240234375, 514.2908935546875,
    516.7755737304688, 515.6683959960938, -1000, 518.6121826171875, 514.5867919921875,
    522.845947265625, 524.4762573242188, 523.3802490234375, -1000, 516.0840454101562,
    509.1940612792969, 515.4495239257812, 517.8367919921875, 527.5464477539062, 529.817626953125,
    533.9971313476562, 543.0060424804688, 514.9671630859375, 507.55023193359375, 485.49530029296875,
    483.1195068359375, 488.61553955078125, 509.78680419921875, 507.83203125, 506.53179931640625,
    496.9813232421875, 493.33203125, 493.6134338378906, 494.96075439453125, 495.7315368652344,
    510.46466064453125, 518.302734375, 525.993408203125, 523.1409301757812, 521.0925903320312,
    516.7919921875, 515.3282470703125, 515.6151123046875, 511.5998840332031, 513.2291870117188,
    511.3891906738281, 511.5015869140625, 521.9365844726562, 513.3793334960938, 513.9793701171875,
    513.010498046875
  ],
  resultPupilCenterY: [
    395.70013427734375, 390.72222900390625, 391.9997863769531, 381.77996826171875,
    366.2328186035156, 343.1174011230469, 333.8653564453125, 347.7583312988281, 356.941162109375,
    360.2309265136719, 363.31707763671875, 372.7512512207031, 371.7372741699219, 367.9023132324219,
    367.89910888671875, 369.43310546875, 370.0401611328125, 368.2671203613281, 372.14202880859375,
    375.4053039550781, 374.8177185058594, 369.4320373535156, 369.23248291015625, 372.8657531738281,
    378.6568908691406, 383.2452087402344, 379.9827880859375, 382.9610900878906, 386.05279541015625,
    393.5655822753906, 395.2841491699219, 398.59796142578125, 396.3584289550781, 396.6402282714844,
    397.96710205078125, 396.50433349609375, 401.2438659667969, 406.8175964355469, 403.1101989746094,
    401.1189270019531, 401.53173828125, 401.72125244140625, 399.3502197265625, 392.8848876953125,
    389.9170227050781, 411.54168701171875, 427.887939453125, 447.8570556640625, 450.6652526855469,
    450.5652160644531, 450.5802001953125, 465.95330810546875, 436.03179931640625, 446.4286804199219,
    447.6098937988281, 446.851806640625, -1000, 444.73193359375, 423.567626953125,
    450.7500915527344, 409.4187316894531, 414.4903869628906, -1000, 408.86279296875,
    383.2322998046875, 382.52960205078125, 381.5116882324219, 382.163818359375, 381.4236145019531,
    378.5224914550781, 383.49188232421875, 409.7062072753906, 409.0796813964844, 403.810791015625,
    401.3132019042969, 400.0562744140625, 396.84698486328125, 395.62347412109375, 396.7923278808594,
    401.9114990234375, 406.0028076171875, 403.5378112792969, 396.0535583496094, 399.57421875,
    396.53656005859375, 398.73101806640625, 400.486572265625, 401.11859130859375, 400.1851501464844,
    397.64312744140625, 395.28607177734375, 392.4973449707031, 391.57684326171875,
    389.4911804199219, 390.16748046875, 391.7602233886719, 385.9495544433594, 384.5969543457031,
    386.3333740234375, 386.74346923828125
  ],
  ringCenterX: [
    522, 516, 492, 482, 472, 467, 472, 481, 486, 484, 487, 493, 492, 492, 493, 497, 498, 498, 488,
    501, 499, 495, 492, 485, 475, 476, 478, 478, 483, 484, 503, 501, 516, 510, 508, 515, 520, 517,
    512, 509, 511, 510, 509, 511, 512, 510, 512, 515, 515, 515, 512, -1000, 510, 520, 523, 523,
    -1000, 521, 517, -1000, 525, -1000, -1000, 525, 514, 520, 523, 530, 532, 538, 546, 524, 517,
    497, 496, 501, 515, 513, 512, 504, 500, 501, -1000, 502, 516, 522, 529, 526, 524, 520, 518, 519,
    515, 516, 515, 515, 521, 514, 515, 515
  ],
  ringCenterY: [
    393, 388, 390, 380, 365, 343, 334, 348, 356, 360, 363, 372, 371, 368, 367, 369, 370, 368, 372,
    374, 374, 368, 369, 373, 378, 383, 380, 383, 385, 393, 395, 398, 395, 396, 397, 395, 400, 406,
    402, 400, 401, 401, 399, 393, 390, 410, 426, 445, 447, 447, 448, -1000, 434, 444, 445, 444,
    -1000, 420, 416, -1000, 399, -1000, -1000, 383, 382, 383, 382, 383, 382, 380, 385, 408, 407,
    402, 399, 398, 396, 395, 396, 400, 404, 402, -1000, 398, 395, 397, 398, 399, 398, 396, 393, 390,
    390, 387, 388, 390, 385, 383, 385, 385
  ]
};

export default {
  name: "PupilConeaChart",
  props: {
    width: { type: Number, default: 1000 },
    height: { type: Number, default: 300 },
    pupilDiameterData: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data() {
    return {
      pupilCalIndex: 0,
      t1t2Index: {
        startTimeIndex: 0,
        endTimeIndex: 0
      },
      ctx: null,
      margin: {
        top: 20,
        right: 20,
        bottom: 20,
        left: 20
      },
      xMax: 10,
      yMax: 12,
      yMin: 0,
      xMin: 0,
      result: []
    };
  },
  computed: {
    chartWidth() {
      return this.width - this.margin.left - this.margin.right;
    },
    chartHeight() {
      return this.height - this.margin.top - this.margin.bottom;
    },
    xStep() {
      return this.chartWidth / 50;
    },
    yStep() {
      return this.chartHeight / 20;
    }
  },
  methods: {
    drawGrid() {
      if (!this.ctx) return;
      this.ctx.save();
      // 绘制普通的格子线
      this.ctx.strokeStyle = "#000";
      this.ctx.lineWidth = 1;
      for (
        let x = this.margin.left + this.xStep;
        x <= this.margin.left + this.chartWidth;
        x += this.xStep
      ) {
        if (x === this.margin.left + this.chartWidth) {
          this.ctx.strokeStyle = "#000";
          this.ctx.lineWidth = 2;
        }
        this.ctx.beginPath();
        this.ctx.moveTo(x, this.margin.top);
        this.ctx.lineTo(x, this.margin.top + this.chartHeight);
        this.ctx.stroke();
      }
      for (
        let y = this.margin.top + this.yStep;
        y <= this.margin.top + this.chartHeight;
        y += this.yStep
      ) {
        this.ctx.beginPath();
        this.ctx.moveTo(this.margin.left, y);
        this.ctx.lineTo(this.margin.left + this.chartWidth, y);
        this.ctx.stroke();
      }

      // 绘制绿色区域
      // ctx.fillStyle = 'rgba(0, 255, 0, 0.3)';
      // ctx.fillRect(margin.left + 2 * xStep * 5, margin.top, 2 * xStep * 5, chartHeight);
      for (let x = 0; x < 50; x++) {
        for (let y = 0; y < 20; y++) {
          const startX = this.margin.left + x * this.xStep;
          const startY = this.margin.top + y * this.yStep;
          if (x >= 10 && x < 20) {
            this.ctx.fillStyle = "rgba(0, 255, 0, 0.3)";
          } else {
            this.ctx.fillStyle = "rgba(90, 86, 87, 0.5)";
          }
          this.ctx.fillRect(startX, startY, this.xStep, this.yStep);
        }
      }

      // 绘制黑色加粗线
      this.ctx.strokeStyle = "#000";
      this.ctx.lineWidth = 2;
      for (let x = this.margin.left; x <= this.margin.left + this.chartWidth; x += 5 * this.xStep) {
        this.ctx.beginPath();
        this.ctx.moveTo(x, this.margin.top);
        this.ctx.lineTo(x, this.margin.top + this.chartHeight);
        this.ctx.stroke();
      }
      for (let y = this.margin.top; y <= this.margin.top + this.chartHeight; y += 5 * this.yStep) {
        this.ctx.beginPath();
        this.ctx.moveTo(this.margin.left, y);
        this.ctx.lineTo(this.margin.left + this.chartWidth, y);
        this.ctx.stroke();
      }
      this.ctx.restore();
    },
    drawAxes() {
      if (!this.ctx) return;
      this.ctx.save();
      this.ctx.strokeStyle = "#000";
      this.ctx.lineWidth = 2;
      // X轴
      this.ctx.beginPath();
      this.ctx.moveTo(this.margin.left, this.margin.top + this.chartHeight);
      this.ctx.lineTo(this.margin.left + this.chartWidth, this.margin.top + this.chartHeight);
      this.ctx.stroke();
      // Y轴
      this.ctx.beginPath();
      this.ctx.moveTo(this.margin.left, this.margin.top);
      this.ctx.lineTo(this.margin.left, this.margin.top + this.chartHeight);
      this.ctx.stroke();
      // X轴标签
      for (let i = 0; i <= 10; i++) {
        const x = this.margin.left + i * 5 * this.xStep;
        this.ctx.beginPath();
        this.ctx.moveTo(x, this.margin.top + this.chartHeight);
        this.ctx.lineTo(x, this.margin.top + this.chartHeight + 5);
        this.ctx.stroke();
        this.ctx.font = "18px serif";
        this.ctx.fillStyle = "#FFF";
        this.ctx.fillText(i, x - 4, this.margin.top + this.chartHeight + 15 + 2);
      }
      // Y轴标签
      for (let i = 0; i <= 12; i += 3) {
        const y = this.margin.top + this.chartHeight - (i / 3) * 5 * this.yStep;
        this.ctx.beginPath();
        this.ctx.moveTo(this.margin.left - 5, y);
        this.ctx.lineTo(this.margin.left, y);
        this.ctx.stroke();
        this.ctx.font = "18px serif";
        this.ctx.fillStyle = "#FFF";
        this.ctx.fillText(i, this.margin.left - 18, y + 6);
      }
      this.ctx.restore();
    },

    drawLine(data) {
      if (!this.ctx) return;
      this.ctx.save();
      this.ctx.lineWidth = 2.5;
      this.ctx.beginPath();
      this.ctx.strokeStyle = "#f00";
      let isLineStarted = false;
      for (let i = 0; i < data.length; i++) {
        //
        //
        const x = this.margin.left + (i / data.length) * this.chartWidth;

        if (data[i] !== null) {
          const y =
            this.margin.top +
            this.chartHeight -
            ((data[i] - this.yMin) / (this.yMax - this.yMin)) * this.chartHeight;
          if (!isLineStarted) {
            this.ctx.moveTo(x, y);
            isLineStarted = true;
          } else {
            this.ctx.lineTo(x, y);
          }
        } else {
          isLineStarted = false;
        }
      }
      this.ctx.stroke();
      this.ctx.restore();

      if (this.t1t2Index.startTimeIndex === 1000 || this.t1t2Index.endTimeIndex === 1000) {
        return;
      }
      this.ctx.save();
      this.ctx.lineWidth = 3.5;
      this.ctx.beginPath();
      this.ctx.strokeStyle = "#87ceeb";
      for (let i = this.t1t2Index.startTimeIndex; i <= this.t1t2Index.endTimeIndex; i++) {
        const x = this.margin.left + (i / data.length) * this.chartWidth;
        if (data[i] !== null) {
          const y =
            this.margin.top +
            this.chartHeight -
            ((data[i] - this.yMin) / (this.yMax - this.yMin)) * this.chartHeight;
          if (!isLineStarted) {
            this.ctx.moveTo(x, y);
            isLineStarted = true;
          } else {
            this.ctx.lineTo(x, y);
          }
        } else {
          isLineStarted = false;
        }
      }
      this.ctx.stroke();
      this.ctx.restore();
    },
    drawVerticalLine(x) {
      if (!this.ctx) return;
      this.ctx.save();
      this.ctx.strokeStyle = "#fff";
      this.ctx.setLineDash([5, 5]);
      this.ctx.beginPath();
      this.ctx.moveTo(x, this.margin.top);
      this.ctx.lineTo(x, this.margin.top + this.chartHeight);
      this.ctx.stroke();
      this.ctx.restore();
    },
    drawWhiteDot(x, y) {
      if (!this.ctx) return;
      this.ctx.fillStyle = "#fff";
      this.ctx.beginPath();
      this.ctx.arc(x, y, 3, 0, Math.PI * 2);
      this.ctx.fill();
    },
    drawPupilDot(index) {
      if (!this.ctx) return;
      const x = this.margin.left + (index / this.result.length) * this.chartWidth;
      const y =
        this.margin.top +
        this.chartHeight -
        ((this.result[index] - this.yMin) / (this.yMax - this.yMin)) * this.chartHeight;
      this.ctx.fillStyle = "#ffeb3b";
      this.ctx.beginPath();
      this.ctx.arc(x, y, 3, 0, Math.PI * 2);
      this.ctx.fill();
    },
    drawChart(data) {
      this.ctx.clearRect(0, 0, this.width, this.height);
      this.drawGrid();
      this.drawAxes();
      this.drawLine(data);
    },
    getCursorPosition(canvas, event) {
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      return { x1: x, y1: y };
    },
    mousemove(event) {
      const data = this.result;
      const canvas = this.$refs.pupilchart;
      const tooltip = this.$refs.tooltip;
      const rect = canvas.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;
      const xValue = ((mouseX - this.margin.left) / this.chartWidth) * this.xMax;
      const x1 = Number(xValue.toFixed(1));
      const mousex1 = (x1 / this.xMax) * this.chartWidth + this.margin.left;

      if (
        mouseX >= this.margin.left &&
        mouseX <= this.margin.left + this.chartWidth &&
        mouseY >= this.margin.top &&
        mouseY <= this.margin.top + this.chartHeight
      ) {
        canvas.style.cursor = "pointer";
        tooltip.style.display = "block";
        let index = Math.round(((mousex1 - this.margin.left) / this.chartWidth) * data.length);

        const x = this.margin.left + (index / data.length) * this.chartWidth;
        const y =
          this.margin.top +
          this.chartHeight -
          ((data[index] - this.yMin) / (this.yMax - this.yMin)) * this.chartHeight;
        const dataY = data[index];
        tooltip.style.left = x + 10 + "px";
        tooltip.style.top = y + 10 + "px";
        if (this.width - x < 200) {
          tooltip.style.left = x - 160 + "px";
        }
        if (dataY && index !== 100) {
          tooltip.textContent = `x: ${xValue.toFixed(1)} s, y: ${dataY.toFixed(2)} mm`;
        }

        // 清除之前的图表
        this.ctx.clearRect(0, 0, this.width, this.height);
        this.drawGrid();
        this.drawAxes();
        this.drawLine(data);
        this.drawVerticalLine(mousex1);

        // 绘制当前鼠标位置的白点
        if (data[index] !== null && index !== 100) {
          this.drawWhiteDot(x, y);
        } else {
          tooltip.style.display = "none";
        }
        this.drawPupilDot(this.pupilCalIndex);
      } else {
        canvas.style.cursor = "default";
        tooltip.style.display = "none";
        this.ctx.clearRect(0, 0, this.width, this.height);
        this.drawChart(data);
        this.drawPupilDot(this.pupilCalIndex);
      }
    },
    mouseleave() {
      const tooltip = this.$refs.tooltip;
      tooltip.style.display = "none";
      this.drawChart(this.result);
      this.drawPupilDot(this.pupilCalIndex);
    },
    init(data) {
      this.ctx = this.$refs.pupilchart.getContext("2d");
      // 鼠标移动事件处理
      this.$refs.pupilchart.addEventListener("mousemove", this.mousemove);

      this.$refs.pupilchart.addEventListener("mouseleave", this.mouseleave);

      this.drawChart(data);
    }
  },

  beforeDestroy() {
    this.$refs.pupilchart.removeEventListener("mousemove", this.mousemove);
    this.$refs.pupilchart.removeEventListener("mouseleave", this.mouseleave);
  },

  mounted() {
    const dataAArr = this.pupilDiameterData
      .map((item) => {
        return item * 2 * window.magecoe.pupilcornea;
      })
      .map((item) => {
        if (item > 0) {
          return item;
        } else {
          return null;
        }
      });

    this.result = dataAArr;
    this.init(dataAArr);

    this.$bus.$on("PUPILCALINDEX", (index) => {
      this.pupilCalIndex = index;
      this.ctx.clearRect(0, 0, this.width, this.height);
      this.drawChart(this.result);
      this.drawPupilDot(this.pupilCalIndex);
    });

    this.$bus.$on("PUPILT1T2INDEX", (item) => {
      this.t1t2Index.startTimeIndex = item.startTimeIndex;
      this.t1t2Index.endTimeIndex = item.endTimeIndex;
      this.ctx.clearRect(0, 0, this.width, this.height);
      this.drawChart(this.result);
      this.drawPupilDot(this.pupilCalIndex);
    });

    this.$bus.$on("PUPILCHARTCHANGE", () => {
      const dataAArr = this.pupilDiameterData
        .map((item) => {
          return item * 2 * window.magecoe.pupilcornea;
        })
        .map((item) => {
          if (item > 0) {
            return item;
          } else {
            return null;
          }
        });

      this.result = dataAArr;
      this.init(dataAArr);
    });

    // this.drawPupilDot(this.pupilCalIndex);
    this.$bus.$emit("PUPILT1T2INDEXF");
  },
  destroyed() {
    this.$bus.$off("PUPILCALINDEX");
    this.$bus.$off("PUPILT1T2INDEX");
    this.$bus.$off("PUPILCHARTCHANGE");
  }
};
</script>

<style lang="less" scoped>
.chart-content {
  position: relative;
  &-tip {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 5px;
    border-radius: 3px;
    pointer-events: none;
    display: none;
    color: white;
    height: 20px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/topography/components/PupilConeaChart.vue